import { render, staticRenderFns } from "./applyCloseOrder.vue?vue&type=template&id=a4cf1d16&"
import script from "./applyCloseOrder.vue?vue&type=script&lang=js&"
export * from "./applyCloseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4cf1d16')) {
      api.createRecord('a4cf1d16', component.options)
    } else {
      api.reload('a4cf1d16', component.options)
    }
    module.hot.accept("./applyCloseOrder.vue?vue&type=template&id=a4cf1d16&", function () {
      api.rerender('a4cf1d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/applyCloseOrder.vue"
export default component.exports